import { t } from "@lingui/macro";
import * as React from "react";
import { Path } from "react-native-svg";

import { Icon, IconProps } from "../../../primitive";

export const DragHandIcon = (props: IconProps) => (
  <Icon viewBox="0 0 20 20" fill="none" title={t`Drag Hand`} {...props}>
    <Path
      d="M2.33601 10.9459L3.14122 10.4091L2.33601 10.9459L6.03914 16.5006C6.59554 17.3352 7.53223 17.8365 8.53529 17.8365H12.0219C13.2423 17.8365 14.4296 17.2797 15.1936 16.2672C16.4495 14.6032 18.5001 11.5943 18.5001 7.83647C18.5001 6.94926 17.9156 6.16809 17.0644 5.91774L9.64076 3.73431C7.82215 3.19942 6.00011 4.56274 6.00011 6.45838V8.62537C6.00011 8.6919 5.98183 8.72151 5.96883 8.73793C5.95063 8.7609 5.91745 8.78645 5.86989 8.80085C5.82233 8.81525 5.78055 8.8124 5.75267 8.80338C5.73274 8.79693 5.70111 8.78243 5.66421 8.72707C5.0515 7.80802 3.80976 7.55967 2.89071 8.17237C1.97165 8.78508 1.7233 10.0268 2.33601 10.9459Z"
      fill="white"
      stroke="currentColor"
      strokeWidth="2"
    />
  </Icon>
);
